import React, { FC, PropsWithChildren } from 'react'
import { Field } from 'react-final-form'

/**
 * Renders `children` only while the `when` field holds one of the `is` values.
 *
 * Visibility only — it deliberately does not write to the form. Nulling the value of a
 * field it hides is FormBuilder's `nullInactiveFields`, applied at validate and submit;
 * doing it from here meant a `form.change` during render (the DFE-3892 class).
 */
const RFFConditional: FC<
  PropsWithChildren<{
    when: string
    is: string | Array<string>
  }>
> = ({ when, is, children }) => (
  <Field name={when} subscription={{ value: true }}>
    {({ input: { value } }) => {
      const isEnabled = typeof is === 'string' ? value === is : is.includes(value)

      return isEnabled ? children : null
    }}
  </Field>
)

export default RFFConditional
